module.exports = __webpack_public_path__ + "4cbaf8baaf686841ca5969aaad477a9e.svg";